import React from 'react';
import { withTranslation } from 'react-i18next';
import Avatar from 'react-avatar';
import PropTypes from 'prop-types';
import ControlCameraIcon from '@material-ui/icons/ControlCamera';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import DirectionsWalkIcon from '@material-ui/icons/DirectionsWalk';
import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';
import { DRIVE_MODE } from '../../../shared/utils/constants';

const SmartGoCard = (props) => {
  const { smartGoCard, t } = props;

  const Icon = (driveMode) => {
    switch (driveMode) {
      case DRIVE_MODE.DRIVING:
        return <DirectionsCarIcon />;
      case DRIVE_MODE.BICYCLING:
        return <DirectionsBikeIcon />;
      case DRIVE_MODE.WALKING:
        return <DirectionsWalkIcon />;
      default:
        return null;
    }
  };

  return (
    <div className="smartgo__Card">
      <div className="avatar">
        <Avatar
          size="40"
          round="20px"
          src={smartGoCard.profilePhotoUrl}
          name={smartGoCard.studentName}
        />
      </div>
      <div className="infos">
        <div>{smartGoCard.studentName}</div>
        <div>{smartGoCard.classesNames}</div>
        <div>{smartGoCard.responsibleName}</div>
        <div>
          {`${t('smartgo.creationDate')}: ${smartGoCard.creationDateMs}`}
        </div>
        <div>
          {` ${t('smartgo.lastUpdate')}: ${smartGoCard.lastLocationUpdate}`}
        </div>
        <div>{` ${t('smartgo.distance')}: ${smartGoCard.distance} ${t(
          'smartgo.meters'
        )}`}</div>
        {smartGoCard.arrivalEstimate && (
          <div>{` ${t('smartgo.arrivalEstimate')}: ${
            smartGoCard.arrivalEstimate
          } `}</div>
        )}
      </div>
      <div className="icons">
        <ControlCameraIcon />
        {Icon(smartGoCard.driveMode)}
      </div>
    </div>
  );
};

SmartGoCard.propTypes = {
  smartGoCard: PropTypes.shape({
    profilePhotoUrl: PropTypes.string,
    studentName: PropTypes.string,
    classesNames: PropTypes.string,
    responsibleName: PropTypes.string,
    creationDateMs: PropTypes.string,
    lastLocationUpdate: PropTypes.string,
    driveMode: PropTypes.string,
    distance: PropTypes.number,
    arrivalEstimate: PropTypes.string,
  }).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(SmartGoCard);
